import React from 'react';
import Logo from '../../image/felt-teachers-logo.png';
import BackDrop from '../Test/BackDrop';
import ApiContext from '../Context/ApiContext';
import { NavLink } from 'react-router-dom';
import SideNav from './SideNav';


const sideDrawer = props => {


    return (
        <ApiContext.Consumer>
            {(context) => {
                return (<div className={(context.sideDrawerStatus) ? 'showSideNav' : 'dissmisSideNav'}>
                    <BackDrop clicked={context.setSideDrawer} />
                    <div className='sideDrawer'>
                        <div className='image'>
                            <img src={Logo} width='80' alt='softskills logo' />
                            <h3>{context.userName}</h3>
                            <h3>{context.email}</h3>
                        </div>
                        <SideNav
                            isLoggedin={props.loggedIn}
                            courseOfStudy={context.courseOfStudy}
                            userName={context.userName}
                            clicked={context.setSideDrawer} />

                        <div className="sidedrawer-footer-right">
                            <p className="footer-company-about">
                                <span>About the company</span><br/>
       At JustCoded Softskills Solutions, we teach you the latest software technology that drives today's business world.
        <br />
                                <NavLink to="/aboutus" className="link">
                                    <i className="fas fa-arrow-right"></i>Learn More
        </NavLink>
                            </p>

                            <div className="footer-icons">
                                <a href="#">
                                    <i className="fab fa-facebook"></i>
                                </a>
                                <a href="#">
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a href="#">
                                    <i className="fab fa-linkedin"></i>
                                </a>
                                <a href="#">
                                    <i className="fab fa-github"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>)
            }}
        </ApiContext.Consumer>)
};

export default sideDrawer;